import React from "react";
// Common Modal

// Mui
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";

// Custom
import ContainedButton from "../../forms/button/ContainedButton";
import { SxProps, Theme } from "@mui/material";

const CommonModal = ({
  title,
  open,
  onClose,
  handleSave,
  body,
  loading = false,
  textModal = false,
  showEditButton = false,
  sx,
  maxWidth = false,
  fullWidth = false,
  dialogContentSx,
}: {
  title?: string;
  open: boolean;
  onClose: () => void;
  handleSave?: () => void;
  body: React.ReactNode;
  loading?: boolean;
  textModal?: boolean;
  showEditButton?: boolean;
  sx?: SxProps<Theme>;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  fullWidth?: boolean;
  dialogContentSx?: SxProps<Theme>;
}) => {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      sx={{
        "& .MuiPaper-root": {
          maxWidth: "none",
          ...(sx as any),
        },
      }}
    >
      {!textModal && (
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <DialogTitle sx={{ m: 0, p: 2 }}>{title}</DialogTitle>
          <IconButton onClick={onClose} sx={{ marginRight: "10px" }}>
            <CloseIcon />
          </IconButton>
        </Stack>
      )}

      <DialogContent dividers={!textModal} sx={dialogContentSx}>
        {body}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        {showEditButton && (
          <ContainedButton
            label={"Save"}
            sx={{
              width: "fit-content",
              fontWeight: 600,
              color: "#ffffff",
            }}
            onClick={handleSave}
            loading={loading}
          />
        )}

        <ContainedButton
          label={"Close"}
          bgColor={"linear-gradient(180deg, #FF7F7F 0%, #FF4D4D 100%)"}
          sx={{
            fontWeight: 600,
            color: "#ffffff",
          }}
          onClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CommonModal;
